import { Record } from 'immutable';

export default class BookingPaymentItemAttestedDateRecord extends Record({
  id: undefined,
  absentReason: undefined,
  date: undefined,
  payment: undefined,
  price: undefined,
  resourceCost: undefined,
  resourceFee: undefined,
}) {
}
